import { Navigate } from "react-router-dom";
import { useAuthStore, hydrateAccountFromToken } from "@/lib/store";
import { ReactNode, useEffect } from "react";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const account = useAuthStore((s) => s.account);
  const hasToken =
    typeof window !== "undefined" && !!localStorage.getItem("access_token");

  // If we have a token but no account in the store (e.g. after a hard reload),
  // populate it from JWT claims.
  useEffect(() => {
    if (hasToken && !account) {
      hydrateAccountFromToken();
    }
  }, [hasToken, account]);

  if (!hasToken) {
    const returnTo = encodeURIComponent(
      window.location.pathname + window.location.search
    );
    return <Navigate to={`/auth/login?next=${returnTo}`} replace />;
  }

  return <>{children}</>;
}
